import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2b38f2aa&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=2b38f2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38f2aa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/Login.vue
// module id = 214
// module chunks = 1